import { $isElementNode, LexicalEditor, LexicalNode } from 'lexical';

export function exportChildrenToDOM(
  parentNode: LexicalNode,
  container: HTMLElement,
  editor: LexicalEditor,
): void {
  if (!$isElementNode(parentNode)) {
    return;
  }

  const children = parentNode.getChildren();
  for (const child of children) {
    const childDOM = exportNodeToDOM(child, editor);
    if (childDOM) {
      container.appendChild(childDOM);
    }
  }
}

function exportNodeToDOM(node: LexicalNode, editor: LexicalEditor): Node | null {
  const exportOutput = node.exportDOM(editor);
  if (!exportOutput?.element) {
    return null;
  }

  const element = exportOutput.element;

  if ($isElementNode(node)) {
    const children = node.getChildren();
    for (const child of children) {
      const childDOM = exportNodeToDOM(child, editor);
      if (childDOM) {
        element.appendChild(childDOM);
      }
    }
  }

  return element;
}
